import { Component, OnInit } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../../environments/environment";

@Component({
  selector: "app-college-scholarship-list",
  templateUrl: "./college-scholarship-list.component.html",
  styleUrls: ["./college-scholarship-list.component.scss"],
})
export class CollegeScholarshipListComponent implements OnInit {
  public list = [];
  message = null;
  class = null;
  userRole = localStorage.getItem("userRole");

  constructor(private router: Router, private http: HttpClient) {}

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: this.userRole == "admin" ? true : false,
    },
    delete: {
      confirmDelete: true,
    },
    columns: {
      college: {
        title: "College",
        valuePrepareFunction: (cell, row) => {
          return row.collegeDetails ? row.collegeDetails.collegename : 'N/A';
        },
        filterFunction: (cell?: any, search?: string) => {
          if (search.length === 0) {
            return true;
          }
          const collegeName = cell.collegeDetails ? cell.collegeDetails.collegename.toLowerCase() : '';
          return collegeName.includes(search.toLowerCase());
        }
      },
      course: {
        title: "Course",
        valuePrepareFunction: (cell, row) => {
          return row.courseDetails ? row.courseDetails.name : 'N/A';
        },
        filterFunction: (cell?: any, search?: string) => {
          if (search.length === 0) {
            return true;
          }
          const courseName = cell.courseDetails ? cell.courseDetails.name.toLowerCase() : '';
          return courseName.includes(search.toLowerCase());
        }
      },
      streams: {
        title: "Stream",
        valuePrepareFunction: (cell, row) => {
          return row.streamsDetails ? row.streamsDetails.name : 'N/A';
        },
        filterFunction: (cell?: any, search?: string) => {
          if (search.length === 0) {
            return true;
          }
          const streamName = cell.streamsDetails ? cell.streamsDetails.name.toLowerCase() : '';
          return streamName.includes(search.toLowerCase());
        }
      },
      reviews: {
        title: "Reviews",
        valuePrepareFunction: (value) => {
          return value || 'N/A';
        }
      },
      _id: {
        title: "Actions",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          return `
            <a href="#/college-details/edit-college-scholarship/${row._id}" class="btn btn-sm btn-primary me-1">
              <i class="fa fa-pencil"></i> Edit
            </a>
            ${this.userRole == "admin" ? 
            `<button class="btn btn-sm btn-danger" data-delete data-id="${row._id}">
              <i class="fa fa-trash"></i> Delete
            </button>` : ''}
          `;
        },
        filter: false,
        sort: false,
      },
    },
    pager: {
      display: true,
      perPage: 10
    },
    attr: {
      class: 'table table-bordered'
    }
  };

  ngOnInit() {
    this.loadScholarshipData();
  }

  loadScholarshipData() {
    let user = localStorage.getItem("userId");
    
    if (this.userRole == "admin") {
      this.http
        .get<any>(`${environment.apiUrl}/collegescholarship/`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            this.list = data.results || data;
            console.log('Scholarship data loaded:', this.list);
          },
          (err: HttpErrorResponse) => {
            console.error("Error loading scholarship data:", err);
            this.message = "Failed to load scholarship data";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    } else {
      this.http
        .get<any>(`${environment.apiUrl}/collegescholarship/${user}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            this.list = data.results || data.data || [];
          },
          (err: HttpErrorResponse) => {
            console.error("Error loading user scholarship data:", err);
            this.message = "Failed to load scholarship data";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    }
  }

  onCustomAction(event) {
    if (event.action === 'edit') {
      this.router.navigate([`/college-details/edit-college-scholarship/${event.data._id}`]);
    } else if (event.action === 'delete') {
      this.deleteRecord(event);
    }
  }

  deleteRecord(event) {
    if (confirm("Are You Sure You Want To Delete This Scholarship Record?")) {
      this.http
        .delete<any>(`${environment.apiUrl}/collegescholarship/${event.data._id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            if (data.message == "Logged Out!") {
              this.router.navigateByUrl("/auth/login");
              return;
            }
            if (data.status == "500") {
              this.message = data.message;
              this.class = "btn-primary rounded px-1 py-1";
            } else {
              this.message = "Successfully Deleted";
              this.class = "btn-success rounded px-1 py-1";
              this.loadScholarshipData(); // Reload the data
            }
          },
          (err: HttpErrorResponse) => {
            console.error("Error deleting scholarship record:", err);
            this.message = "Error deleting scholarship record";
            this.class = "btn-danger rounded px-1 py-1";
          }
        );
    }
  }
}